  class NotLoggedOnError extends Error {
    constructor() {
      super("Sorry you need to login again");
      this.name = "NotLoggedOnError";
    }
  }

  export default NotLoggedOnError;